<template>
  <div class="box">
    <div class="box-header">
      <h4 class="box-title">
        <i class="icofont-listine-dots"></i> Resultado do Indicador
      </h4>
    </div>
    <div class="box-body">
      <table
        class="table table-responsive table-bordered text-center table2"
        id="table"
      >
        <thead>
          <tr>
            <th>Por</th>
            <!--
                        <th>
                            Estimadas
                            <span v-b-tooltip.hover title="Quantidade de gestantes estimadas pelo Ministério da Saúde (denominador estimado)" class="icon-tooltip">
                                <i class="icofont-info-circle"></i>
                            </span>
                        </th>
                        -->
            <th>
              Numerador
              <span
                v-b-tooltip.hover
                title="Gestantes com atendimento odontológico realizado."
                class="icon-tooltip"
              >
                <i class="icofont-info-circle"></i>
              </span>
            </th>
            <th>
              Denominador
              <span
                v-b-tooltip.hover
                :title="denominadorTitle"
                class="icon-tooltip"
              >
                <i class="icofont-info-circle"></i>
              </span>
            </th>
            <th>Resultado</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Município</td>
            <!--
                        <td class="text-center font-weight-bold">
                            <loader :value="por_municipio_gestantes_estimadas" :loading="loading"></loader>
                        </td>
                        -->
            <td class="text-center font-weight-bold">
              <loader
                :value="por_municipio_odontologia"
                :loading="loading"
              ></loader>
            </td>
            <td class="text-center font-weight-bold">
              <loader
                :value="por_municipio_gestantes_informadas"
                :loading="loading"
              ></loader>
            </td>
            <td
              class="text-center font-weight-bold"
              v-bind:class="corTextoResultado(por_municipio_resultado)"
            >
              <loader
                :value="por_municipio_resultado"
                :isPercentage="true"
                :loading="loading"
              ></loader>
            </td>
          </tr>
          <tr>
            <td>Equipe</td>
            <!--
                        <td class="text-center font-weight-bold">
                            <loader :value="por_equipe_gestantes_estimadas" :loading="loading"></loader>
                        </td>
                        -->
            <td class="text-center font-weight-bold">
              <loader
                :value="por_equipe_odontologia"
                :loading="loading"
              ></loader>
            </td>
            <td class="text-center font-weight-bold">
              <loader
                :value="por_equipe_gestantes_informadas"
                :loading="loading"
              ></loader>
            </td>
            <td
              class="text-center font-weight-bold"
              v-bind:class="corTextoResultado(por_equipe_resultado)"
            >
              <loader
                :value="por_equipe_resultado"
                :isPercentage="true"
                :loading="loading"
              ></loader>
            </td>
          </tr>
          <tr>
            <td>ACS</td>
            <!--
                        <td>-</td>
                        -->
            <td class="text-center font-weight-bold">
              <loader
                :value="secretaria_municipal_de_saude_no_acs_denominador"
                :loading="loading"
              ></loader>
            </td>
            <td class="text-center font-weight-bold">
              <loader
                :value="secretaria_municipal_de_saude_no_acs_numerador"
                :loading="loading"
              ></loader>
            </td>
            <td
              class="text-center font-weight-bold"
              v-bind:class="
                corTextoResultado(
                  Math.round(secretaria_municipal_de_saude_no_acs_resultado)
                )
              "
            >
              <loader
                :value="secretaria_municipal_de_saude_no_acs_resultado"
                :isPercentage="true"
                :loading="loading"
              ></loader>
            </td>
          </tr>
        </tbody>
      </table>
      <FonteEsusPecGlobal
        texto="Atendimentos registrados até"
        :data="data_secretaria_de_saude"
      />
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import utils from '@/mixins/utils.js'

export default {
  components: {
    Loader,
  },
  props: {
    secretaria_municipal_de_saude_no_municipio_denominador: {
      type: [Number, String],
      default: '',
    },
    secretaria_municipal_de_saude_no_municipio_numerador: {
      type: [Number, String],
      default: '',
    },
    secretaria_municipal_de_saude_no_municipio_resultado: {
      type: [Number, String],
      default: '',
    },
    secretaria_municipal_de_saude_na_equipe_denominador: {
      type: [Number, String],
      default: '',
    },
    secretaria_municipal_de_saude_na_equipe_numerador: {
      type: [Number, String],
      default: '',
    },
    secretaria_municipal_de_saude_na_equipe_resultado: {
      type: [Number, String],
      default: '',
    },
    secretaria_municipal_de_saude_no_acs_denominador: {
      type: [Number, String],
      default: '',
    },
    secretaria_municipal_de_saude_no_acs_numerador: {
      type: [Number, String],
      default: '',
    },
    secretaria_municipal_de_saude_no_acs_resultado: {
      type: [Number, String],
      default: '',
    },
    secretaria_municipal_de_saude_no_municipio_meta: {
      type: [Number, String],
      default: '',
    },
    secretaria_municipal_de_saude_na_equipe_meta: {
      type: [Number, String],
      default: '',
    },
    secretaria_municipal_de_saude_no_acs_meta: {
      type: [Number, String],
      default: '',
    },
    por_municipio_gestantes_estimadas: {
      type: [String, Number],
      default: '',
    },
    por_municipio_gestantes_informadas: {
      type: [String, Number],
      default: '',
    },
    por_municipio_odontologia: {
      type: [String, Number],
      default: '',
    },
    por_municipio_resultado: {
      type: [String, Number],
      default: '',
    },
    por_equipe_gestantes_estimadas: {
      type: [String, Number],
      default: '',
    },
    por_equipe_gestantes_informadas: {
      type: [String, Number],
      default: '',
    },
    por_equipe_odontologia: {
      type: [String, Number],
      default: '',
    },
    por_equipe_resultado: {
      type: [String, Number],
      default: '',
    },
    data_secretaria_de_saude: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    cod_ibge: {
      type: String,
      default: '',
    },
  },
  mixins: [utils],
  data() {
    return {}
  },
  computed: {
    denominadorTitle() {
      let text = 'Gestantes a parir no quadrimestre atual. '
      if (parseInt(this.por_municipio_gestantes_estimadas) === 0) {
        text +=
          'Como o cadastro passou de 85% do público alvo, desconsiderou-se a estimativa. Equipe não usa mais estimativa.'
      } else {
        text += `A estimativa no indicador é de ${this.por_municipio_gestantes_estimadas} pessoas para o município.`
      }
      return text
    },
  },
  methods: {
    corTextoResultado(valor) {
      if (valor >= 60) {
        return 'blue'
      } else {
        return 'red'
      }
    },
  },
}
</script>

<style></style>
